const DATE_FIELDS = ['date', 'startAt', 'endAt']

function normalizeDate(value) {
  if (!value) return null

  if (value instanceof Date) {
    return value.toISOString()
  }

  const date = new Date(value)
  if (isNaN(date.getTime())) return value

  return date.toISOString()
}

export function deepEqual(a, b, key = null) {
  if (a === b) return true

  if (key && DATE_FIELDS.includes(key)) {
    return normalizeDate(a) === normalizeDate(b)
  }

  if (
    a !== null &&
    b !== null &&
    typeof a === 'object' &&
    typeof b === 'object'
  ) {
    const keysA = Object.keys(a)
    const keysB = Object.keys(b)

    if (keysA.length !== keysB.length) return false

    return keysA.every((k) => deepEqual(a[k], b[k], k))
  }

  return false
}
